import { ensureSlash } from '@qdabra/forms-shared/urlHelpers';
import {
    __,
    allPass,
    any,
    includes,
    pathSatisfies,
    propEq,
    startsWith,
} from 'ramda';
import { getLastSegment } from '../../../utility/urlHelpers.new';
import { CONNECTION_TYPE_WEBSERVICE } from '../../DataConnections/dataConnection.types';
import { ENVIRONMENT_VARIABLE_TOKEN_PREFIX } from '../../helpers/valueTokens';

// DocumentService, DocumentServiceEx, AdUserInfo, AdminService,
// DbxlImportExport, SampleDocumentService, SampleDocumentServiceEx,
// DbxlXsnService, DbxlResource, DbxlLicensing, DbxlStatistics,
// AnonDocumentService, AnonDocumentServiceEx, SystemDocumentTypes,
export const NS_QDABRA_WEBSERVICE = 'http://qdabra.com/webservices/';

// QueryDB, QuerySharePoint, AnonQueryDB, EnumDB, DbxlKeyService
export const NS_DATABASE_WEBSERVICE = 'http://qdabra.com/databaseservice';

// DocumentServiceUserKEy
export const NS_DOCUMENT_USER_KEY =
    'http://qdabra.com/querydbxldocumentwithuserkey';

// QueryDBUserKey
export const NS_QUERYDB_USER_KEY = 'http://qdabra.com/querydbwithuserkey';

const DBXL_SERVICE_NAMESPACES = [
    NS_QDABRA_WEBSERVICE,
    NS_DATABASE_WEBSERVICE,
    NS_DOCUMENT_USER_KEY,
    NS_QUERYDB_USER_KEY,
];

const DBXL_USERKEY_NAMESPACES = [NS_DOCUMENT_USER_KEY, NS_QUERYDB_USER_KEY];

export const isUserKeyNamespace = includes(__, DBXL_USERKEY_NAMESPACES);

const startsWithDbxlNamespace = (soapAction) =>
    any(startsWith(__, soapAction), DBXL_SERVICE_NAMESPACES);

// DataConnection -> Boolean
const isInDbxlNamespace = pathSatisfies(startsWithDbxlNamespace, [
    'definition',
    'soapAction',
]);

export const isDbxlDataConnection = allPass([
    propEq('type', CONNECTION_TYPE_WEBSERVICE),
    isInDbxlNamespace,
]);

export const changeServiceUrlBase = (url, newBase) => {
    const prefix =
        newBase && newBase.startsWith(ENVIRONMENT_VARIABLE_TOKEN_PREFIX)
            ? newBase
            : ensureSlash(newBase);
    return prefix + getLastSegment(url);
};
